<body class="home-page01 container-fluid p21920">

  <div class="content">
    <div class="main">
      <div class="container-fluid full-width">
        <div class="top-cont">
          <div class="business-services__container_pay">
            <div class="payment-services__inner-div_bus cus-bnd">
              <nav aria-label="breadcrumb" class="bread_cus">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item active" aria-current="page">Product Terms & Conditions
                  </li>
                </ol>
              </nav>
              <span>
                <h3 class="payment-services__inner-div--heading_bus">Terms and Conditions</h3><br>
                <hr class="payment-services__hr_bus">
              </span>
              <div class="payment-services__inner-div--content bus_wor0">
                Last Updated as of December 14, 2023
              </div>


            </div>

          </div>
          <img class="vector-01" alt="background-arc" src="../../../../assets/redesignImages/Vector.png">

        </div>

        <div class="dis-up up-1">

          <p class="subhead">THESE TERMS AND CONDITIONS (T&Cs) OF SERVICE CONTAIN IMPORTANT INFORMATION
            REGARDING YOUR LEGAL RIGHTS, REMEDIES, AND OBLIGATIONS, AS WELL AS CONDITIONS, LIMITATIONS, AND
            EXCLUSIONS THAT MIGHT APPLY TO YOU. PLEASE READ THESE T&Cs CAREFULLY. THESE T&Cs FURTHER REQUIRE
            THE USE OF ARBITRATION ON AN INDIVIDUAL BASIS TO RESOLVE DISPUTES, RATHER THAN JURY TRIALS OR
            CLASS ACTIONS. </p>
          <p class="space"></p>

          <p>These T&Cs are a legally binding agreement between you (<b>you</b> or <b>Customer</b>) and UPS
            Capital Insurance Agency, Inc. (<b>we</b> or <b>UPSCIA</b>) and govern and control your rights
            with respect to any products or services provided to you by UPSCIA. UPSCIA, a licensed insurance
            producer, desires to help Customer obtain one or more insurance policies (<b>Policies</b>) to
            enable Customer to insure its shipments of goods. In furtherance thereof, you agree as follows:
          </p>
          <p class="space"></p>

          <p><b>1.&nbsp&nbsp&nbsp&nbsp&nbsp POLICIES:</b> You acknowledge and agree that the terms of each
            Policy will govern all matters related to such Policy, including your rights against the
            insurance company, how the Policy may be terminated or modified, and who may have any rights or
            interests thereunder. The availability of coverage under each Policy depends on the Policy
            language, the facts of the claim and the law of the jurisdiction governing the interpretation of
            the Policy. In no event shall these T&Cs be deemed to modify any Policy. You further acknowledge
            and agree that UPSCIA is not an insurance company, and that UPSCIA is not responsible or liable
            for any loss or damage claimed under any Policy.</p>
          <p class="space"></p>

          <p><b>2.&nbsp&nbsp&nbsp&nbsp&nbsp INSURANCE SERVICES:</b> By choosing to use UPSCIA’s insurance
            services (<b>Insurance Services</b>), you agree to: (i) designate UPSCIA as your broker of
            record or agent of record (as applicable); (ii) authorize UPSCA to communicate such designation
            as broker or agent of record to any insurance carrier, your prior insurance producer, and any
            other person or entity UPSCIA determines should be advised; and (iii) permit UPSCIA to receive
            any commission or other form of compensation that any insurance carrier or affinity partner
            agrees to pay to UPSCIA in connection with the provision of Insurance Services.</p>
          <p class="space"></p>

          <p><b>3.&nbsp&nbsp&nbsp&nbsp&nbsp NO SPECIAL RELATIONSHIP:</b> You acknowledge that in providing the
            Insurance Services to you, we may act as an insurance broker for purposes of facilitating the
            placement of the Policies. In connection with that relationship, you warrant that you have
            comprehensively reviewed and read these T&Cs, the Policies, and any other documents we may
            provide you. You further warrant that you will immediately contact us in writing in the event of
            any provisions thereof that you do not understand. Absent such inquiries, to the fullest extent
            permitted by law, you agree that we have no duty to interpret or explain insurance coverage
            applications, restrictions and/or limitations to you. </p>
          <p class="space"></p>

          <p><b>4.&nbsp&nbsp&nbsp&nbsp&nbsp RESTRICTIONS ON USE; NO INDIRECT POLICY PARTICIPANTS:</b> You
            agree to use the Insurance Services and Policies solely for your own use and benefit or for that
            of your organization. You may not use the Insurance Services or Policies on behalf of an
            affiliated or unaffiliated third party or for any other commercial, financial or other similar
            purpose without the prior written consent of UPSCIA. Further, nothing herein constitutes
            authorization for you to offer participation or coverage under any Policy to any other person or
            entity. You will notify us in writing promptly if you become aware that anyone has offered (or
            intends to offer) participation or coverage under any Policy to any other person or entity. Any
            such purported participation or coverage in violation of this provision shall be null and void.
          </p>
          <p class="space"></p>

          <p><b>5.&nbsp&nbsp&nbsp&nbsp&nbsp UPDATES TO THE T&Cs:</b> UPSCIA may modify these T&Cs at any time
            with or without notice to you. Your continued use of the Insurance Services will be deemed as
            your acceptance of any such new terms and conditions. The T&Cs are also published electronically
            on the UPSCIA website at <a class="acc-classs"
              href="https://www.insureshield.com/us/en/legal/terms-and-conditions-upscia.html" target="_blank"
              rel="noopener">https://www.insureshield.com/us/en/legal/terms-and-conditions-upscia.html</a>.
            Customer agrees to be bound by the version of these T&Cs in effect when Insurance Services are
            provided. It is the Customer’s sole responsibility to keep apprised of any changes to the
            published T&Cs.</p>
          <p class="space"></p>

          <p><b>6.&nbsp&nbsp&nbsp&nbsp&nbsp INDEMNIFICATION:</b> Customer agrees to indemnify, defend, and
            hold harmless, at Customer’s sole cost and expense, UPSCIA and its affiliated companies, their
            officers, directors, employees, agents, and their successors and assigns, from and against any
            and all any losses, damages, demands, claims, liabilities, costs (including legal costs) and
            expenses of any kind, suffered or incurred by UPSCIA, arising from or relating to any breach or
            violation of these T&Cs or the Additional Terms (as defined herein) or Policy, or any violation
            of applicable law, rule or regulation or any rights of another, by Customer or its affiliates,
            or their officers, directors, employees or agents.</p>
          <p class="space"></p>

          <p><b>7.&nbsp&nbsp&nbsp&nbsp&nbsp AGREEMENT TO ARBITRATE CLAIMS:</b> Customer and UPSCIA agree that,
            except for disputes that qualify for state courts of limited jurisdiction (such as small claims,
            justice of the peace, magistrate court, and similar courts with monetary limits of less than
            $30,000 on their jurisdictions over civil disputes), any controversy or claim, whether at law or
            equity, arising out of or related to these T&Cs or the provision of Insurance Services by
            UPSCIA, regardless of the date of accrual of such dispute, shall be resolved in its entirety by
            individual (not class-wide nor collective) binding arbitration. Customer and UPSCIA expressly
            agree that the foregoing obligation to arbitrate disputes regardless of the date of accrual of
            such disputes includes, but is not limited to, preexisting disputes and disputes that arise from
            or relate to shipments made at the time of a previous version of these T&Cs.</p>
          <p class="space"></p>
          <p>Arbitration is the submission of a dispute to a neutral arbitrator, instead of a judge or jury,
            for a final and binding decision, known as an “award.” Arbitration provides for more limited
            discovery than in court and is subject to limited review by courts. Each party has an
            opportunity to present evidence to the arbitrator in writing or through witnesses. An arbitrator
            can only award the same damages and relief that a court can award under the law and must honor
            these T&Cs. Customer and UPSCIA agree that their sole relationship is a contractual one governed
            by the T&Cs and any applicable Policy or other written agreements with UPSCIA.</p>

          <p class="space"></p>
          <p><b>(a)&nbsp&nbsp&nbsp Institutional Arbitration:</b> The arbitration shall be conducted by the
            American Arbitration Association (<b>AAA</b>) in accordance with its Commercial Arbitration
            Rules or, provided that Customer is an individual consumer and using UPSCIA’s Insurance Services
            for personal (not business) use, the Consumer Arbitration Rules (collectively referred to herein
            as the <b>AAA Rules</b>), and judgment on the award may be entered in any court of competent
            jurisdiction. The AAA Rules, including instructions for how to initiate arbitration, are
            available at http://www.adr.org or by calling the AAA at 1-800-778-7879. The arbitrator shall
            decide all issues of the case on the basis of the applicable law, not equity. If Customer
            initiates arbitration, Customer must serve UPSCIA’s registered agent for service of process,
            Corporation Service Company, which has locations in every state. Information also can be found
            on the website of your local Secretary of State.</p>
          <p class="space"></p>
          <p class="subhead">Any arbitration under these T&Cs will take place on an individual basis; class,
            mass, consolidated or combined actions or arbitrations or proceeding as a private attorney
            general are not permitted. Customer and UPSCIA each waive their right to trial by jury. Customer
            and UPSCIA are further giving up their ability to participate in a class, mass, consolidated or
            combined action or arbitration.
          </p>
          <p class="space"></p>
          <p><b>(b)&nbsp&nbsp&nbsp Place of Arbitration/Number of Arbitrators/Costs of Arbitration/Governing
              Law/Survival:</b> Any arbitration will take place in the county where Customer resides and
            will be determined by a single arbitrator. The initial filing fee required of Customer by the
            AAA Rules shall be paid by Customer to the extent such fee does not exceed the amount of the fee
            required to commence a similar action in a court that otherwise would have jurisdiction. For all
            non-frivolous complaints, UPSCIA will pay the amount of such fee in excess of that amount. The
            arbitrator will allocate the administrative costs and arbitral fees consistent with the
            applicable rules of the AAA. Reasonable attorney’s fees and expenses will be allocated or
            awarded only to the extent such allocation or award is available under applicable law.</p>
          <p class="space"></p>
          <p>All issues are for the arbitrator to decide, except that issues relating to the scope,
            application, and enforceability of the arbitration provision, issues relating to the
            interpretation or application of the provision guarantying access to state courts of limited
            jurisdiction for qualifying disputes, and issues relating to interpretation or application of
            the prohibition on participation in class, mass, consolidated or combined actions or
            arbitrations or proceedings as a private attorney general, are all issues for a court to decide.
            The Federal Arbitration Act governs the interpretation and enforcement of this provision. This
            agreement to arbitrate shall survive termination of the Policies and/or Customer’s and UPSCIA’s
            agreement to be bound to these T&Cs.</p>
          <p class="space"></p>
          <p>The arbitration demand must plead with particularity facts that demonstrate the dispute does not
            qualify for state courts of limited jurisdiction (such as small claims, justice of the peace,
            magistrate court, and similar courts with monetary limits of less than $30,000 on their
            jurisdictions over civil disputes). Where the dispute relates to a shipment, in order to
            commence arbitration, the arbitration demand must provide particularized information that
            identifies the shipment or shipments, such as by the date(s) of shipment and UPS tracking
            number(s). </p>
          <p class="space"></p>
          <p><b>(c)&nbsp&nbsp&nbsp Severability:</b> Notwithstanding anything to the contrary in the AAA
            Rules, if any part of this arbitration provision is deemed invalid or ineffective for any
            reason, this shall not affect the validity or enforceability of the remainder of this
            arbitration provision, and the arbitrator shall have the authority to amend any provisions
            deemed invalid or ineffective to make the same valid and enforceable. </p>
          <p class="space"></p>
          <p><b>(d)&nbsp&nbsp&nbsp Desk Arbitration:</b> For all disputes concerning an amount less than
            fifteen thousand dollars ($15,000.00), the parties shall submit their arguments and evidence to
            the arbitrator in writing and the arbitrator shall make an award based only on the documents; no
            hearing will be held unless the arbitrator in his or her discretion, and upon request of a
            party, decides it is a necessity to require an in-person hearing. For a dispute governed by the
            AAA Consumer Arbitration Rules where the arbitrator issues an award in favor of Claimant, and
            concerning an award between fifteen thousand dollars ($15,000.00) and fifty thousand dollars
            ($50,000.00), inclusive, UPSCIA shall refund Customer’s filing fee under the AAA Rules following
            conclusion of the arbitration, provided that Customer agrees that both parties shall submit
            their arguments and evidence to the arbitrator in writing and that the arbitrator shall make an
            award based only on the documents, without a hearing being held. Notwithstanding this provision,
            the parties may agree to proceed with desk arbitration at any time. </p>
          <p class="space"></p>
          <p><b>(e)&nbsp&nbsp&nbsp Access to Small Claims Courts:</b> All parties shall retain the right to
            seek adjudication in a state court of limited jurisdiction, such as small claims, justice of the
            peace, magistrate court, and similar courts with monetary limits of less than $30,000 on their
            jurisdiction over civil disputes, for individual disputes within the scope of such court’s
            jurisdiction. If the claims asserted in any request or demand for arbitration could have been
            brought in such a court of limited jurisdiction, then either party may elect to require that the
            claims be heard in such court of limited jurisdiction, rather than in arbitration, by notifying
            the other party of that election in writing. </p>
          <p class="space"></p>
          <p><b>(f)&nbsp&nbsp&nbsp Acknowledgements:</b> Pursuant to these T&Cs, Customer and UPSCIA
            acknowledge and agree that each party is hereby:</p>
          <p class="space"></p>
          <p><b>a.&nbsp&nbsp&nbsp</b> WAIVING THE RIGHT TO HAVE A TRIAL BY JURY TO RESOLVE ANY DISPUTE ALLEGED
            AGAINST CUSTOMER, UPSCIA, OR ANY PERSON OR ENTITY IN CONNECTION WITH THESE T&Cs, ANY POLICY
            AND/OR COVERAGE OF SHIPMENTS THEREUNDER;</p>
          <p class="space"></p>
          <p><b>b.&nbsp&nbsp&nbsp</b> WAIVING THE RIGHT TO HAVE A COURT, OTHER THAN A STATE COURT OF LIMITED
            JURISDICTION AS DEFINED ABOVE, RESOLVE ANY DISPUTE ALLEGED AGAINST CUSTOMER, UPSCIA, OR ANY
            PERSON OR ENTITY IN CONNECTION WITH THESE T&Cs, ANY POLICY AND/OR COVERAGE OF SHIPMENTS
            THEREUNDER;</p>
          <p class="space"></p>
          <p><b>c.&nbsp&nbsp&nbsp</b> WAIVING THE RIGHT TO HAVE A COURT REVIEW ANY DECISION OR AWARD OF AN
            ARBITRATOR, WHETHER INTERIM OR FINAL, EXCEPT FOR APPEALS BASED ON THOSE GROUNDS FOR VACATUR
            EXPRESSLY SET FORTH IN SECTION 10 OF THE FEDERAL ARBITRATION ACT; AND</p>
          <p class="space"></p>
          <p><b>d.&nbsp&nbsp&nbsp</b> WAIVING THE RIGHT TO SERVE AS A REPRESENTATIVE, AS A PRIVATE ATTORNEY
            GENERAL, OR IN ANY OTHER REPRESENTATIVE CAPACITY, JOIN AS A CLASS MEMBER, AND/OR TO PARTICIPATE
            AS A MEMBER OF A CLASS OF CUSTOMERS IN ANY CLASS, MASS, CONSOLIDATED OR COMBINED ACTION OR
            ARBITRATION FILED AGAINST CUSTOMER, UPSCIA, OR ANY PERSON OR ENTITY IN CONNECTION WITH THESE
            T&Cs, ANY POLICY AND/OR COVERAGE OF SHIPMENTS THEREUNDER.</p>
          <p class="space"></p>
          <p><b>(g)&nbsp&nbsp&nbsp Award:</b> The arbitrator may award money or equitable relief in favor of
            only the individual party seeking relief and only to the extent necessary to provide relief
            warranted by that party’s individual claim. Similarly, an arbitration award and any judgment
            confirming the arbitration award apply only to that specific case; the judgment cannot be used
            in any other case except to enforce the award itself. To reduce the time and expense of the
            arbitration, the arbitrator will not provide a statement of reasons for the award unless a brief
            explanation of the reasons is requested by one of the parties. Unless both Customer and UPSCIA
            agree otherwise, the arbitrator may not consolidate more than one person’s claims and may not
            otherwise preside over any form of a representative, private attorney general or class
            proceeding.</p>
          <p class="space"></p>
          <p><b>(h)&nbsp&nbsp&nbsp Confidentiality of Arbitration:</b> Notwithstanding anything to the
            contrary in the AAA Rules, Customer and UPSCIA agree that the filing of arbitration, the
            arbitration proceeding, any documents exchanged or produced during the arbitration proceeding,
            any briefs or other documents prepared for the arbitration, and the arbitral award shall all be
            kept fully confidential and shall not be disclosed to any other person or entity, except to the
            extent necessary to enforce this arbitration provision, any arbitral award or other rights of
            the parties, or as required by law or court order. This confidentiality provision does not
            foreclose the AAA from reporting certain consumer arbitration case information as required by
            state law.</p>
          <p class="space"></p>
          <p><b>8.&nbsp&nbsp&nbsp&nbsp&nbsp LIMITATION OF LIABILITY, DISCLAIMER OF DAMAGES, AND DISCLAIMER OF
              WARRANTIES:</b></p>
          <p class="space"></p>
          <p><b>(a)&nbsp&nbsp&nbsp Limitation of Liability for Direct Damages; Disclaimer of Indirect
              Damages:</b> Customer agrees that the cumulative aggregate liability of UPSCIA and its
            affiliates for all losses, claims, suits, controversies, breaches or damages for any cause
            whatsoever (Loss) and regardless of the form of action or legal theory (including negligence)
            shall be limited to: (i) if the Loss relates to a shipment, the total insured value amount
            declared during the shipment booking process for the shipment at issue in the Loss or, if there
            is no such declared value, the fair market value of such shipment (as reasonably determined by
            UPSCIA); or (ii) if the Loss does not relate to a shipment, one hundred dollars ($100.00), in
            each case less any amount(s) recovered or recoverable from any other source, including, but not
            limited to, any insurance proceeds that reduce the amount of the Loss under the applicable
            Policy or any other policy of insurance. NOTWITHSTANDING THE FOREGOING LIMITATION, EXCEPT AS
            OTHERWISE REQUIRED BY APPLICABLE LAW, CUSTOMER AGREES THAT UPSCIA WILL NOT BE LIABLE TO CUSTOMER
            FOR ANY INDIRECT, INCIDENTAL, CONSEQUENTIAL, EXEMPLARY, PUNITIVE, OR SPECIAL DAMAGES WHATSOEVER,
            INCLUDING LOST PROFITS, REGARDLESS OF THE FORM OF THE ACTION OR THE THEORY OF RECOVERY
            (INCLUDING NEGLIGENCE OR RECKLESSNESS), AND REGARDLESS OF WHETHER SUCH DAMAGES WERE FORESEEABLE
            OR WHETHER UPSCIA OR ANY PERSON OR ENTITY HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
          </p>
          <p class="space"></p>
          <p><b>(b)&nbsp&nbsp&nbsp Disclaimer of Warranties:</b> EXCEPT AS OTHERWISE EXPRESSLY STATED IN THESE
            T&Cs AND THE APPLICABLE POLICY, UPSCIA MAKES NO WARRANTIES, EITHER EXPRESS OR IMPLIED, OF ANY
            KIND TO THE FULLEST EXTENT PERMITTED BY LAW. EXCEPT AS OTHERWISE EXPRESSLY STATED IN THESE T&Cs
            AND THE APPLICABLE POLICY, UPSCIA EXPRESSLY DISCLAIMS, AND CUSTOMER EXPRESSLY WAIVES, ANY AND
            ALL WARRANTIES, INCLUDING THOSE OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE. NO
            DESCRIPTIONS OR SPECIFICATIONS, WHETHER OR NOT INCORPORATED INTO THESE T&Cs AND THE APPLICABLE
            POLICY, SHALL CONSTITUTE WARRANTIES OF ANY KIND.</p>
          <p class="space"></p>
          <p><b>(c)&nbsp&nbsp&nbsp Access from Outside the U.S.:</b> If Customer accesses UPSCIA’s Insurance
            Services from outside the United States, Customer shall be responsible for compliance with all
            foreign and local laws. UPSCIA does not provide Insurance Services (or other services) to
            governments, governmental agencies, businesses, individuals, other groups, or any of their
            agents that are subject to U.S. trade sanctions. By using the Insurance Services, Customer
            represents and warrants that Customer is not subject to any U.S. trade sanctions.</p>
          <p class="space"></p>
          <p><b>9.&nbsp&nbsp&nbsp&nbsp&nbsp EFFECTIVENESS; GOVERNING LAW:</b> These T&Cs shall become
            effective when accepted (or deemed to have been accepted) by you and shall be governed by and
            construed in accordance with the internal laws of the State of Georgia, without regard to
            conflict of laws principles.</p>
          <p class="space"></p>
          <p><b>10.&nbsp&nbsp&nbsp JURY TRIAL AND CLASS ACTION WAIVER: </b>CUSTOMER and UPSCIA acknowledge
            that the right to trial by jury is a constitutional right but may be waived in certain
            circumstances. To the extent permitted by law, CUSTOMER and UPSCIA knowingly and voluntarily
            waive any right to trial by jury in the event of litigation arising out of or related to these
            T&Cs. In addition, CUSTOMER waives its right to join a class of other CUSTOMERs to bring a claim
            against UPSCIA, or to bring or be a class member in any class action or class arbitration
            proceeding. This jury trial and class action waiver will not affect or be interpreted as
            modifying in any fashion the Agreement to Arbitrate set forth ABOVE, which contains its own jury
            trial and class action waiver. If a court or arbitrator determines that the Agreement to
            Arbitrate is invalid or unenforceable, the jury trial and class action waiver will continue to
            apply.</p>
          <p class="space"></p>
          <p><b>11.&nbsp&nbsp&nbsp INCORPORATION OF ADDITIONAL TERMS; FUTURE CHANGES: </b>Customer agrees to
            accept and be bound by the additional agreements, terms of use, notices and disclosures
            available at upscapital.com (collectively, the Additional Terms). By using or continuing to use
            UPSCIA’s Insurance Services, Customer acknowledges that Customer has read and understands these
            Additional Terms and agrees to be bound by them, including, without limitation: </p>
          <p class="space"></p>
          <p><b>(a)&nbsp&nbsp&nbsp</b> the UPS Capital Group Technology Agreement (the current version of
            which is available at <a class="acc-classs"
              href="https://upscapital.com/technology-agreement/">https://upscapital.com/technology-agreement/</a>),
            and</p>
          <p class="space"></p>
          <p><b>(b)&nbsp&nbsp&nbsp</b> the UPS Capital Privacy Notice (the current version of which is
            available at <a class="acc-classs"
              href="https://upscapital.com/privacy-notice/">https://upscapital.com/privacy-notice/</a>).
          </p>
          <p class="space"></p>
          <p>The T&CS and Additional Terms comprise the complete and exclusive agreement of the parties,
            including any of UPSCIA’s affiliates, except as modified by any existing or future written
            agreement between the parties, and may not be contradicted, modified or supplemented by any oral
            agreement or by any implied-by-law covenant.</p>
          <p class="space"></p>
          <p><b>12.&nbsp&nbsp&nbsp CONTACT US:</b> If you have questions or want more information about the
            Policies, insurance coverage, pricing, the claims process and documents or any issues discussed
            in these T&Cs, email UPSCIA at <a class="acc-classs" href="mailto:capitalus@ups.com">capitalus@ups.com</a>.
          </p>
          <p class="space"></p>








        </div>

      </div>


    </div>
  </div>

</body>